import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResultInfoGenericDto } from '../dto/ResultInfoDto';
import { FormInfoByCisloJrDto } from '../dto/FormInfoByCisloJrDto';
import { Observable } from 'rxjs';
import { SlucovaniOddiluPopInfoDto } from '../dto/SlucovaniOddiluPopInfoDto';
import { PuvodUjDto } from '../dto/Uj/PuvodUjDto';
import { UserInfoDto } from '../dto/UserInfoDto';

@Injectable({
  providedIn: 'root'
})
export class FillFormService {

  constructor(
    private http: HttpClient,
  ) { }

  private apiLicenceDodavatelInfo: string = "api/Formulare/GetLicenceDodavatelInfo/";
  private apiPopInfo: string = "api/Formulare/GetPopInfo";
  private apiPrihlasenyUzivatelInfo: string = "api/Formulare/GetPrihlasenyUzivatelInfo";
  private apiUserInfo: string = "api/Formulare/GetUserInfo";
  private apiPlatnaUj: string = "api/Formulare/GetPlatnaUj/";
  private apiPuvodUj: string = "api/Formulare/GetPuvodUj/";


  /**
   * Vrací informace o dodavateli a licenci dle čísla jednotného registru.
   * @param cisloJr
   */
  getLicenceDodavatelInfo(cisloJr: string): Observable<ResultInfoGenericDto<FormInfoByCisloJrDto>> {
    return this.http.get<ResultInfoGenericDto<FormInfoByCisloJrDto>>(this.apiLicenceDodavatelInfo + cisloJr);
  }

  /**
   * Vrací informace o POP.
   * @param cisloPop
   */
  getPopInfo(cisloPop: string): Observable<ResultInfoGenericDto<SlucovaniOddiluPopInfoDto>> {
    let params = new HttpParams().set("cisloPop", cisloPop);
    return this.http.get<ResultInfoGenericDto<SlucovaniOddiluPopInfoDto>>(this.apiPopInfo, {params: params});
  }


  /**
   * Vrátí stručné info o přihlášeném uživateli.
  **/
  getPrihlasenyUzivatelInfo(): Observable<ResultInfoGenericDto<FormInfoByCisloJrDto>> {
    return this.http.get<ResultInfoGenericDto<FormInfoByCisloJrDto>>(this.apiPrihlasenyUzivatelInfo);
  }

  /**
   * Vrátí osobní údaje přihlášeného uživatele pro předvyplnění formuláře.
   */
  getUserInfo(): Observable<ResultInfoGenericDto<UserInfoDto>> {
    return this.http.get<ResultInfoGenericDto<UserInfoDto>>(this.apiUserInfo);
  }


  /**
   * Vrátí platnou Uj.
   * @param cuj
   */
  getPlatnaUj(cuj: string): Observable<PuvodUjDto> {
    return this.http.get<PuvodUjDto>(this.apiPlatnaUj + cuj);
  }


  /**
   * Vrátí původ Uj.
   * @param cuj
   */
  getPuvodUj(cuj: string): Observable<PuvodUjDto> {
    return this.http.get<PuvodUjDto>(this.apiPuvodUj + cuj);
  }
}
